import React, { useId, useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { cn } from '../../src/lib/utils';
export type FaqItem = {
  question: string;
  answer: string;
  link?: {
    label: string;
    href: string;
  };
};

/** Accessible accordion. Answers stay in the DOM (hidden attribute) for find-in-page and crawlers. */
export function FaqList({
  items,
  defaultOpen = 0
}: {
  items: FaqItem[];
  defaultOpen?: number | null;
}) {
  const [open, setOpen] = useState<number | null>(defaultOpen);
  const baseId = useId();
  return <ul className="divide-y divide-hairline rounded-2xl border border-hairline bg-panel" data-id="element-1282" data-mp="22j9kyw9r8vr3">
      {items.map((faq, index) => {
      const expanded = open === index;
      const buttonId = `${baseId}-q-${index}`;
      const panelId = `${baseId}-a-${index}`;
      const external = faq.link && !faq.link.href.startsWith('/');
      return <li key={faq.question} data-id="element-1283" data-mp="1eqt24ji70zqq" data-mpi={index}>
            <h3 data-id="element-1284" data-mp="1jqyobk5p1u1f">
              <button id={buttonId} type="button" aria-expanded={expanded} aria-controls={panelId} onClick={() => setOpen(expanded ? null : index)} className="flex min-h-[56px] w-full items-center justify-between gap-4 px-5 py-4 text-left text-[15px] font-semibold text-text-primary transition-colors hover:text-lime focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-lime" data-id="element-1285" data-mp="1jqfhayhl0q26">
                {faq.question}
                <ChevronDownIcon className={cn('h-4 w-4 shrink-0 text-text-tertiary transition-transform duration-200 motion-reduce:transition-none', expanded && 'rotate-180')} aria-hidden="true" data-id="element-1286" data-mp="1hsu9bk649bvn" />
              </button>
            </h3>
            <div id={panelId} role="region" aria-labelledby={buttonId} hidden={!expanded} className="px-5 pb-5 text-sm leading-relaxed text-text-secondary" data-id="element-1287" data-mp="38507n2rk7pj0">
              {faq.answer}
              {faq.link ? <>
                  {' '}
                  <a href={faq.link.href} {...external ? {
              target: '_blank',
              rel: 'noopener noreferrer'
            } : {}} className="font-semibold text-lime underline-offset-2 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime" data-id="element-1288" data-mp="3m8z9kv8ljnr8">
                    {faq.link.label}
                  </a>
                </> : null}
            </div>
          </li>;
    })}
    </ul>;
}